import Button, { IButton } from "./Button";

interface IAnchor extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  buttonProps: IButton;
}

const LinkButton = ({ buttonProps, children, ...props }: IAnchor) => {
  return (
    <a {...props}>
      <Button {...buttonProps}>{children}</Button>
    </a>
  );
};

export default LinkButton;
